const MenuItem = props => 
  <div className={(props.className?props.className:"px-2") + " p-relative clickable"} onClick={props.onClick}>
    {props.badge ? <div className="badge">{props.badge}</div> : ''}
    <a href={props.link}>{props.title}</a>
  </div>;

export default MenuItem;